import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { SvgIcon, DEFAULT_SIZE } from '../svg-icon'
import styles from './base-position-icon.module.css'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32,
    children: 0,
    width: DEFAULT_SIZE
}

const propTypes = {
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    childWrapperClassName: PropTypes.string,
    width: PropTypes.number,
    wrapperClassName: PropTypes.string,
    wrapperIconClassName: PropTypes.string
}
/**
 * Stateless function representing a extensible base position icon.
 *
 * @todo [WFICON-60] Move or rework BasePositionIcon and BasePositionIconWithShadow
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <BasePositionIcon width={12}>12</BasePositionIcon>
 */
const BasePositionIcon = props => {
    const { childWrapperClassName, children, width, wrapperClassName, wrapperIconClassName } = props
    const style = {
        fontSize: Math.floor(width / 2.5),
        marginBottom: Math.floor(width / 9)
    }

    return (
        <div className={cx(styles.wrapper, wrapperClassName)} style={{ width: width, height: width }}>
            <SvgIcon
                viewBox="0 0 48 48"
                {...props}
                className={cx(styles['position-icon'], 't3sel-base-position-icon', wrapperIconClassName)}
            >
                <path
                    d={`M36.338,9.392a17.576,17.576,0,0,0-24.746,0,17.313,17.313,
                    0,0,0,0,24.6C14.764,37.139,23.967,44.3,23.967,44.3s9.206-7.163,
                    12.374-10.311a17.315,17.315,0,0,0,0-24.6`}
                />
                <path
                    d={`M35.278,10.532a16.07,16.07,0,0,0-22.625,0,15.83,15.83,0,
                    0,0,0,22.491c2.9,2.877,11.309,9.424,11.309,9.424S32.383,35.9,
                    35.28,33.021a15.831,15.831,0,0,0,0-22.489`}
                />
            </SvgIcon>
            <div className={cx(styles.number, childWrapperClassName)} style={style}>
                {children}
            </div>
        </div>
    )
}

BasePositionIcon.defaultProps = defaultProps
BasePositionIcon.propTypes = propTypes

export { BasePositionIcon }
